import "select2";

jQuery(function ($) {
  console.log("regional.js ready");

  const data = [
    {
      label: "Credible Elections",
      value: 0.52,
    },
    {
      label: "Inclusive Suffrage",
      value: 0.95,
    },
    {
      label: "Free Political Parties",
      value: 0.53,
    },
    {
      label: "Elected Government",
      value: 0.66,
    },
    {
      label: "Effective Parliament",
      value: 0.49,
    },
    {
      label: "Local Democracy",
      value: 0.19,
    },
    {
      label: "Access to Justice",
      value: 0.54,
    },
    {
      label: "Civil Liberties",
      value: 0.53,
    },
    {
      label: "Basic Welfare",
      value: 0.69,
    },
    {
      label: "Political Equality",
      value: 0.47,
    },
    {
      label: "Judicial Independence",
      value: 0.54,
    },
    {
      label: "Absence of Corruption",
      value: 0.52,
    },
    {
      label: "Predictable Enforcement",
      value: 0.5,
    },
    {
      label: "Personal integrity and Security",
      value: 0.54,
    },
    {
      label: "Electoral Participation",
      value: 0.64,
    },
    {
      label: "Civic Engagement",
      value: 0.6,
    },
    {
      label: "Civil Society",
      value: 0.47,
    },
  ];

  const baseUrl = $('#base-url').data('base-url');

  // Chart labels
  const labels = [
    'Credible Elections',
    'Inclusive Suffrage',
    'Free Political Parties',
    'Elected Government',
    'Effective Parliament',
    'Local Democracy',

    'Access to Justice',
    'Civil Liberties',
    'Basic Welfare',
    'Political Equality',

    'Judicial Independence',
    'Absence of Corruption',
    'Predictable Enforcement',
    'Personal integrity & Security',

    'Electoral Participation',
    'Civic Engagement',
    'Civil Society',
  ];

  let canvas = document.getElementById("regional-spider-chart-canvas");
  let ctx;
  let cvWidth;
  let cvHeight;
  let webLength;
  let centerX;
  let centerY;

  const totalLabels = labels.length;
  const startingAngle = -90; // Start drawing at 12 o'clock

  const indicesData = $('#regional-spider-chart-canvas').data('indices');

  console.log('indicesData', indicesData);

  function drawSpiderChart(data) {
    // Canvas width set to 2.01 to avoid clipping when set to 2
    canvas.width = canvas.getBoundingClientRect().width * 2.01;
    canvas.height = canvas.width; // Make a square canvas
    cvWidth = canvas.width;
    cvHeight = canvas.height;
    webLength = cvWidth / 2 * 0.5; // Half of web diameter
    centerX = cvWidth / 2;
    centerY = cvHeight / 2;

    ctx = canvas.getContext("2d");
    ctx.strokeStyle = "#ffffff55";
    ctx.lineWidth = 1.5;

    ctx.clearRect(0, 0, cvWidth, cvHeight);
    drawWeb();
    drawLoop(webLength);
    drawLoop(webLength * 0.5);
    drawLoop(webLength * 0.5 * 0.5);
    drawLoop(webLength * 0.5 * 0.5 * 0.5);
    drawText(indicesData);
    drawData(indicesData);
  }
  // drawSpiderChart END

  function drawWeb() {
    // Drawing radiant lines
    for (let i = 0; i < totalLabels; i++) {
      ctx.beginPath();
      ctx.moveTo(cvWidth / 2, cvWidth / 2);

      let angle = startingAngle + i * 360 / totalLabels;

      let toX = centerX + Math.cos(Math.PI * angle / 180) * webLength;
      let toY = centerY + Math.sin(Math.PI * angle / 180) * webLength;

      ctx.lineTo(toX, toY);
      ctx.stroke();
    }
  }
  // drawWeb END

  function drawLoop(length) {
    let startX = centerX + Math.cos(Math.PI * startingAngle / 180) * length;
    let startY = centerY + Math.sin(Math.PI * startingAngle / 180) * length;

    ctx.beginPath();
    ctx.moveTo(startX, startY);

    // Drawing outer loop
    for (let i = 1; i < totalLabels; i++) {
      let angle = startingAngle + i * 360 / totalLabels;
      let toX = centerX + Math.cos(Math.PI * angle / 180) * length;
      let toY = centerY + Math.sin(Math.PI * angle / 180) * length;

      ctx.lineTo(toX, toY);
    }

    ctx.closePath();
    ctx.stroke();
  }
  // drawLoop END

  function drawText(data) {
    const fontSize = Math.floor(cvWidth * 0.012);
    console.log('fontSize', fontSize);

    for (let i = 0; i < totalLabels; i++) {
      let x;
      let y;
      let txt = labels[i].toUpperCase();

      ctx.save();
      ctx.font = fontSize + "px aileron";
      ctx.textAlign = "left";
      ctx.textBaseline = "middle";
      ctx.fillStyle = "#FFFFFFBB";

      let txtWidth = ctx.measureText(txt).width;
      let angle = startingAngle + i * 360 / totalLabels;

      if (angle > 90) {
        x = centerX + Math.cos(Math.PI * angle / 180) * (webLength + 25 + txtWidth);
        y = centerY + Math.sin(Math.PI * angle / 180) * (webLength + 25 + txtWidth);
      } else {
        x = centerX + Math.cos(Math.PI * angle / 180) * (webLength + 25);
        y = centerY + Math.sin(Math.PI * angle / 180) * (webLength + 25);
      }

      ctx.translate(x, y);

      if (angle > 90) {
        ctx.transform(-1, 0, 0, -1, 0, 0);
      }

      ctx.rotate(Math.PI / 180 * angle, 255, 255);
      ctx.fillText(txt, 0, 0);
      ctx.restore();
    }

    // return;

    for (let i = 0; i < totalLabels; i++) {
      let x;
      let y;
      let txt = parseFloat(data[i].toFixed(2));

      ctx.save();
      ctx.font = "bold " + fontSize + "px aileron";
      ctx.textAlign = "left";
      ctx.textBaseline = "middle";
      ctx.fillStyle = "#FFFFFF";

      let labelWidth = ctx.measureText(labels[i].toUpperCase()).width;
      let txtWidth = ctx.measureText(txt).width;
      let angle = startingAngle + i * 360 / totalLabels;

      if (angle > 90) {
        x = centerX + Math.cos(Math.PI * angle / 180) * (webLength + 20 + labelWidth + txtWidth);
        y = centerY + Math.sin(Math.PI * angle / 180) * (webLength + 20 + labelWidth + txtWidth);
      } else {
        x = centerX + Math.cos(Math.PI * angle / 180) * (webLength + 20 + labelWidth);
        y = centerY + Math.sin(Math.PI * angle / 180) * (webLength + 20 + labelWidth);
      }

      ctx.translate(x, y);

      if (angle > 90) {
        ctx.transform(-1, 0, 0, -1, 0, 0);
      }

      ctx.rotate(Math.PI / 180 * angle, 255, 255);
      ctx.fillText(txt, 0, 0);
      ctx.restore();
    }
  }
  // drawText END

  function drawData(data) {
    const totalData = data.length;

    let startX = centerX + Math.cos(Math.PI * startingAngle / 180) * (webLength * data[0]);
    let startY = centerY + Math.sin(Math.PI * startingAngle / 180) * (webLength * data[0]);

    ctx.save();
    ctx.beginPath();
    ctx.moveTo(startX, startY);

    // Drawing data loop
    for (let i = 1; i < totalLabels; i++) {
      let angle = startingAngle + i * 360 / totalLabels;
      let toX = centerX + Math.cos(Math.PI * angle / 180) * (webLength * data[i]);
      let toY = centerY + Math.sin(Math.PI * angle / 180) * (webLength * data[i]);

      ctx.lineTo(toX, toY);
    }

    ctx.closePath();

    ctx.strokeStyle = "#2260DA";
    ctx.lineWidth = 3;
    ctx.stroke();

    let grd = ctx.createLinearGradient(cvWidth / 2, cvHeight * 0.33, cvWidth / 2, cvHeight * 0.66);
    grd.addColorStop(0, "#2260DA55");
    grd.addColorStop(1, "#2260DA00");
    ctx.fillStyle = grd;
    ctx.fill();

    ctx.restore();
  }
  // drawData END

  drawSpiderChart(data);

  $(window).on('resize', function() {
    console.log('resize');
    drawSpiderChart(data);
  });

  $('#regional-page-archive').select2({
    placeholder: "Select an option",
    // allowClear: true,
    minimumResultsForSearch: Infinity
  });

  $('#regional-page-archive').on('change', function() {
    const elm = $(this);
    const year = elm.val();

    $('.regional-node-card').hide();
    $('.regional-node-card.' + year).show();
  });
});
